import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';

import EntityStateUpdater from 'component/EntityStateUpdaterV2';

import Loader from 'components/layout/Loader';
import SimpleSubmitButton from 'components/layout/SimpleSubmitButton';
import Data from 'components/Data';

import FormInput from 'components/forms/FormInput';
import FormErrors from 'components/forms/FormErrors';

class MyParentBankData extends EntityStateUpdater {
  constructor(props) {
    super(props, { metaIdentifier: 'financialBankData', dataProps: 'parent' }); // pass the configuration to entity state updater
  }

  onSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    this.validateEntity(() => {
      this.props.onSubmit({
        financial: {
          bankData: this.state.entity.__getStoredData(),
        },
      });
    });
  };

  render() {
    const {
      intl: { messages },
      formStatus,
    } = this.props;
    const { entityLoaded, entity } = this.state;

    return (
      <div>
        <Data dataName="financialBankData" /> {/* fetch meta data */}
        <FormErrors formStatus={formStatus} />
        {!entityLoaded ? (
          <Loader />
        ) : (
          <form method="post" onSubmit={this.onSubmit}>
            <p className="form-group-title">{messages.formGroup.bank_account}</p>
            <div class="form-group-attached m-b-20">
              <FormInput
                label={messages.bank_name}
                name="bankName"
                value={entity.getBankName}
                meta={entity.getBankNameMetaInformation}
                validation={entity.getBankNameValidationResult}
                onChange={this.updateEntity}
                disabled={formStatus.pending}
              />
              <FormInput
                label={messages.account_holder}
                name="accountHolder"
                value={entity.getAccountHolder}
                meta={entity.getAccountHolderMetaInformation}
                validation={entity.getAccountHolderValidationResult}
                onChange={this.updateEntity}
                disabled={formStatus.pending}
              />
              <FormInput
                label={messages.bank_location}
                name="bankLocation"
                value={entity.getBankLocation}
                meta={entity.getBankLocationMetaInformation}
                validation={entity.getBankLocationValidationResult}
                onChange={this.updateEntity}
                disabled={formStatus.pending}
              />
              <FormInput
                label={messages.iban}
                name="iban"
                value={entity.getIban}
                meta={entity.getIbanMetaInformation}
                validation={entity.getIbanValidationResult}
                onChange={this.updateEntity}
                disabled={formStatus.pending}
              />
              <FormInput
                label={messages.swift_bic}
                name="swiftBic"
                value={entity.getSwiftBic}
                meta={entity.getSwiftBicMetaInformation}
                validation={entity.getSwiftBicValidationResult}
                onChange={this.updateEntity}
                disabled={formStatus.pending}
              />
            </div>

            <SimpleSubmitButton
              label={messages.save}
              entityChanged={this.getEntityChanged()}
              errorButton={this.hasValidationErrorButton()}
              pending={formStatus.pending}
              block
              defaultStyle="primary"
            />
          </form>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    meta: state.entityMeta,
    formStatus: state.formStatus.myParentEdit,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: args => {
      formStatusDispatchHelper('myParentEdit', '/api/clients/parent.json', args, 'put', dispatch);
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MyParentBankData)
);
